/* ==========================================================================
   CarouselRxjs > Prototype
   ========================================================================== */

/* Modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const Swiper = require('swiper/dist/js/swiper');

const { actions, types } = require('./store/actions');
const { reducer } = require('./store/reducer');

const { resizeWindow } = require('../../../../events/resize');

const vendorConfig = require('./vendor/config');

const carousel = {
    /* Setup swiper */
    setupSwiper() {
        if (this.swiper) return this;

        /* Config */
        const { swiper = {}, hasAutoplay, hasBreakpoints, hasNavigation, hasPagination } = this.config;

        if (hasNavigation) {
            this.element.parentNode
                .querySelectorAll('.carousel-rxjs__navigation')
                .forEach(item => item.classList.add(this.id));
        }

        if (hasPagination) {
            this.element.parentNode.querySelector('.carousel-rxjs__pagination').classList.add(this.id);
        }

        /* Create 3rd party library swiper instance */
        this.swiper = new Swiper(this.hooks.swiper, {
            ...vendorConfig({ hasAutoplay, hasBreakpoints, hasNavigation, hasPagination, id: this.id }),
            ...swiper
        });

        return this;
    },
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            carousel: reducer
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy()),
            display: () => this.store.dispatch(actions.display()),
            hide: () => this.store.dispatch(actions.hide())
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Destroy swiper */
                this.swiper.destroy();

                /* Remove from DOM */
                this.element.parentNode.removeChild(this.element);

                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());
                [...Object.keys(this)].forEach(key => delete this[key]);
            }),
            display: this.store.subscribe((state, action) => {
                if (action.type !== types.DISPLAY) return;

                /* Data */
                const { css } = this.config;

                this.element.classList.remove(css.hidden);
            }),
            hide: this.store.subscribe((state, action) => {
                if (action.type !== types.HIDE) return;

                /* Data */
                const { css } = this.config;

                this.element.classList.add(css.hidden);
            })
        };

        return this;
    },
    /* Start */
    start() {
        if (!this.config.start) return this;

        const { autoResize = true } = this.config;

        if (!autoResize) {
            return this;
        }

        /* Resize */
        resizeWindow(250);

        return this;
    },
    /* Init */
    init() {
        if (!this.config.init) return this;

        /* Setup swiper */
        this.setupSwiper();

        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        return this;
    }
};

module.exports = carousel;
